import React from "react";
//#region types
import { DialogProps, ContentDialogContentType } from "models/propTypes/dialogPropTypes";
//#endregion
//#region components
import DialogLayout from "components/common/dialogs/_layout";
import FileViwerContextProvider from "../fileViewer/context/contextProvider";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ContentDialog: React.FC<DialogProps> = (props) => {
  const ContextProvider = props.contextProvider;
  const dialogLayout = (
    <DialogLayout {...props} class={clsx(props.className ? props.className : "", cssExports.contentDialog)}>
      {props.children as ContentDialogContentType}
    </DialogLayout>
  );

  return (
    <FileViwerContextProvider>
      {ContextProvider ? (
        <ContextProvider {...props.contextProviderProps}>{dialogLayout}</ContextProvider>
      ) : (
        dialogLayout
      )}
    </FileViwerContextProvider>
  );
};

export default ContentDialog;
